module.exports = __webpack_public_path__ + "static/media/Express_Icon.98ff4822.png";